import { render } from "./DummySprintDeleteMark.vue?vue&type=template&id=5eacf6fa&scoped=true"
import script from "./DummySprintDeleteMark.vue?vue&type=script&lang=js"
export * from "./DummySprintDeleteMark.vue?vue&type=script&lang=js"

import "./DummySprintDeleteMark.vue?vue&type=style&index=0&id=5eacf6fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eacf6fa"]])

export default __exports__